import useEntity from 'recoil/useEntity/useEntity'
import checkResultsTableAtom from '../components/CheckResultsTable/checkResultsTable.atom'
import { InspectorCheckResult } from '../inspection.types'
import inspectionApi from '../inspection.api'

const useInspectorCheckResult = (id: InspectorCheckResult['id'] | undefined) => {
  const { entity, loading, setEntity } = useEntity<InspectorCheckResult>({
    resource: 'inspector-check-results',
    atom: checkResultsTableAtom,
    entityId: id ?? '',
    itemFetcher: inspectionApi.getCheckResult,
    forceLoad: false,
  })

  return { checkResult: entity, loading, setCheckResult: setEntity }
}

export default useInspectorCheckResult
